export default "__VITE_ASSET__DFbKlw8k__"